import type {
  ReadCheckIdType,
  ReadPointUserLoginType,
  ReadPointUsersReferralType,
  ReqHeaderType,
  ResReadPointLedgerListType,
  ResReadPointLoginType,
  ResReadPointMainType,
  ResReadPointTargetType,
} from '@/types';
import { sendRequest } from '../AxiosRequest';
import { axiosPost } from '../AxiosApi';
import type { CustomAxiosResponse } from '../AxiosResponse';

export const readCheckId = async (readCheckIdType: ReadCheckIdType) => {
  const payload = {
    path: '/v1/point-users/check-id',
    body: { ...readCheckIdType },
  };
  return sendRequest(payload, 'readCheckId', axiosPost);
};

export const readCheckReferral = async (readPointUsersReferralType: ReadPointUsersReferralType) => {
  const payload = {
    path: '/v1/point-users/referral',
    body: { ...readPointUsersReferralType },
  };
  return sendRequest(payload, 'readCheckReferral', axiosPost);
};
export const readLogin = async (
  readPointUserLoginType: ReadPointUserLoginType,
): Promise<CustomAxiosResponse<ResReadPointLoginType>> => {
  const payload = {
    path: '/v1/point-users/login',
    body: { ...readPointUserLoginType },
  };
  return sendRequest(payload, 'readLogin', axiosPost);
};
export const readMain = async (reqHeaderType: ReqHeaderType): Promise<CustomAxiosResponse<ResReadPointMainType>> => {
  const payload = {
    path: '/v1/point-users/main',
    addHeaders: { ...reqHeaderType },
  };
  return sendRequest(payload, 'readMain', axiosPost);
};

export const readTarget = async (
  reqHeaderType: ReqHeaderType,
  point: string,
): Promise<CustomAxiosResponse<ResReadPointTargetType>> => {
  const payload = {
    path: '/v1/point-accumulated/target',
    body: { userPoint: point },
    addHeaders: { ...reqHeaderType },
  };
  return sendRequest(payload, 'readTarget', axiosPost);
};

export const readLedgerList = async (
  reqHeaderType: ReqHeaderType,
): Promise<CustomAxiosResponse<ResReadPointLedgerListType>> => {
  const payload = {
    path: '/v1/point-user-ledger/list',
    addHeaders: { ...reqHeaderType },
  };
  return sendRequest(payload, 'readLedgerList', axiosPost);
};

export const readEarnMorePoints = async (reqHeaderType: ReqHeaderType) => {
  const payload = {
    path: '/v1/point-achieve/list',
    addHeaders: { ...reqHeaderType },
  };
  return sendRequest(payload, 'readEarnMorePoints', axiosPost);
};

export const readAssetInfo = async (reqHeaderType: ReqHeaderType) => {
  const payload = {
    path: '/v1/point-users/season-user-list',
    addHeaders: { ...reqHeaderType },
  };
  return sendRequest(payload, 'readEarnMorePoints', axiosPost);
};
